document.addEventListener('product:loaded', function (e) {
  const context = e.detail?.container || document;
  triggerDefaultPurchaseType(context);
});

function triggerDefaultPurchaseType(context = document) {
  const btn = context.querySelector(
    '.purchase-type-btn[aria-pressed="true"]'
  );
  if (!btn || btn.dataset.initialized) return;
  btn.dataset.initialized = 'true';
  btn.click();
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.purchase-type-btn');
  if (!btn) return;

  const wrapper = btn.closest('.purchase-options') || document;

  const type = btn.dataset.type;
  const variantId = btn.dataset.variantId;
  const sellingPlanId = btn.dataset.sellingPlanId;

  // UI state
  wrapper.querySelectorAll('.purchase-type-btn').forEach(el => {
    el.classList.remove('selected');
    el.setAttribute('aria-pressed', 'false');
    el.querySelector('input[type="radio"]').checked = false;
  });

  btn.classList.add('selected');
  btn.setAttribute('aria-pressed', 'true');
  btn.querySelector('input[type="radio"]').checked = true;

  // Your existing logic
  togglePurchaseType(type, variantId, sellingPlanId);
});


function togglePurchaseType(type, vId, spId) {
  if(type === 'oneTime') {
    document.getElementById("one-time-purchase-section").style.display = "block";
    document.getElementById("subscription-section").style.display = "none";
    $('.one-time-section').addClass('active-radio-purchase');
    $('#one-time-purchase-section').addClass('purchase-active-section');
    $('.subscribe-section').removeClass('active-radio-purchase');
    $('#subscription-section').removeClass('purchase-active-section');
    switchBottle(vId, 1);
  } else {
    document.getElementById("one-time-purchase-section").style.display = "none";
    document.getElementById("subscription-section").style.display = "block";
    $('.subscribe-section').addClass('active-radio-purchase');
    $('#subscription-section').addClass('purchase-active-section');
    $('.one-time-section').removeClass('active-radio-purchase');
    $('#one-time-purchase-section').removeClass('purchase-active-section');
    switchPlan(vId, spId, 0);
  }
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-subscription-btn');
  if (!btn) return;

  const gallery = $('.product-gallery')[0];

  const sellingPlanId = btn.dataset.sellingPlanId;
  const variantId = btn.dataset.variantId;
  const qty = btn.dataset.qty;
  //const mediaId = btn.dataset.mediaId;

  // UI state
  gallery
    .querySelectorAll('.custom-subscription-btn')
    .forEach(el => {
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    });

  btn.classList.add('is-selected');
  btn.setAttribute('aria-pressed', 'true');

  // Existing logic
  switchPlan(variantId, sellingPlanId, qty);
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-variant-btn');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const qty = btn.dataset.qty;

  // UI state
  const group = btn.closest('.variants-row') || document;
  group.querySelectorAll('.custom-variant-btn').forEach(el => {
    el.setAttribute('aria-pressed', 'false');
  });
  btn.setAttribute('aria-pressed', 'true');

  // Existing logic
  switchBottle(variantId, qty);

  
});

function switchPlan(vId, spId, counter) {
  var bottleElement = document.getElementById('plan_' + vId);

  if (!bottleElement) {
    console.error('Bottle element not found for quantity:', vId);
    return;
  }
  
  var mediaId = bottleElement.getAttribute('data-media-id');
  // Sync gallery (your working solution)
  if (mediaId) {
    updateGalleryByMedia(mediaId, $('.product-gallery')[0]);
  }
  
  document.querySelectorAll('.subscription-label').forEach(el => el.classList.remove('selected-plan'));
  bottleElement.classList.add('selected-plan');
  
  var subscription_name = bottleElement.getAttribute('data-selling-plan-name');
  var subscription_final_price = bottleElement.getAttribute('data-selling-price');
  var subscription_compare_price = bottleElement.getAttribute('data-compare-price');
  
  $('.subscription-main-price').html('$'+subscription_final_price);
  $('.subscription-compare-price').html('<del>$'+subscription_compare_price+'</del>');
  $('.product-final-price').html('&nbsp;<span class="blk-dot">.</span>&nbsp;$' + subscription_final_price + ' / ' + subscription_name.replace(/^Every\s*/i, '').trim());
  updatePlanInfo();
  updateAddToCheckoutAttrs();
}

function switchBottle(n, counter) {
  var bottleElement = document.getElementById('bottle_' + n);

  if (!bottleElement) {
    console.error('Bottle element not found for quantity:', n);
    return;
  }

  // -----------------------------
  // Sync gallery
  // -----------------------------
  var mediaId = bottleElement.getAttribute('data-media-id');
  if (mediaId) {
    updateGalleryByMedia(mediaId, $('.product-gallery')[0]);
  }

  // -----------------------------
  // Update pricing
  // -----------------------------
  var currentPriceValue = bottleElement.getAttribute('data-price');
  var oldPriceValue = bottleElement.getAttribute('data-compare-price');

  $('.one-time-base-price').html(currentPriceValue);
  $('.one-time-com-price').html('<del>' + oldPriceValue + '</del>');
  $('.product-final-price').html('&nbsp;<span class="blk-dot">.</span>&nbsp;' + currentPriceValue);

  // -----------------------------
  // Highlight selected variant
  // -----------------------------
  document.querySelectorAll('.variant').forEach(el => el.classList.remove('selected'));
  bottleElement.classList.add('selected');

  // -----------------------------
  // ✅ Check radio by dynamic ID
  // -----------------------------
  var radio = document.getElementById('qty-' + n);
  if (radio) {
    radio.checked = true;

    // Optional but recommended if other logic depends on it
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  } else {
    console.warn('Radio input not found for variant:', n);
  }

  updateAddToCheckoutAttrs();
}

function updatePlanInfo() {
  const selectedPlan = document.querySelector(
    '.selected-plan .selling_plan_frequency'
  );
  if (!selectedPlan) return;

  const text = selectedPlan.textContent.trim().toLowerCase();

  const qtyEl = document.querySelector('.no-of-qty');
  const daysEl = document.querySelector('.no-of-days');

  if (!qtyEl || !daysEl) return;

  // -----------------------
  // 1) Detect DAYS
  // -----------------------
  let days = 30;

  if (text.includes('monthly')) {
    days = 30;
  } else if (text.includes('bi-monthly')) {
    days = 60;
  } else if (text.includes('quarterly')) {
    days = 90;
  } else if (text.includes('4 months')) {
    days = 120;
  } else if (text.includes('6 months')) {
    days = 180;
  }

  daysEl.textContent = `${days} Days`;

  // -----------------------
  // 2) Detect PAGE TYPE (correct way)
  // -----------------------
  const currentQtyText = qtyEl.textContent.toLowerCase();
  const isPouchPage = currentQtyText.includes('pouch');

  // -----------------------
  // 3) Set QUANTITY
  // -----------------------
  if (isPouchPage) {
    // Bottle page → quantity derived from days
    const pouchQty = Math.max(1, Math.round(days / 30));
    qtyEl.textContent = `${pouchQty} Pouch${pouchQty > 1 ? 'es' : ''}`;

  } else {
    // Bottle page → quantity derived from days
    const bottleQty = Math.max(1, Math.round(days / 30));
    qtyEl.textContent = `${bottleQty} Bottle${bottleQty > 1 ? 's' : ''}`;
  }
}

function updateAddToCheckoutAttrs() {
  const btn = document.getElementById('add-to-checkout');
  if (!btn) return;

  let type = 'oneTime';
  let variantId = null;
  let sellingPlanId = '';

  // purchase type
  const purchaseType = document.querySelector(
    'input[name="purchase-type"]:checked'
  );

  if (purchaseType?.value === 'subscribe') {
    type = 'subscribe';
  }

  if (type === 'subscribe') {
    const selectedPlan = document.querySelector(
      '.subscription-label.selected-plan'
    );

    if (!selectedPlan) return;

    variantId = selectedPlan.id.replace('plan_', '');
    sellingPlanId = selectedPlan.dataset.sellingPlanId;

  } else {
    const qty = document.querySelector(
      'input[name="quantity-value"]:checked'
    );
    if (!qty) return;

    variantId = qty.value;
  }

  // 🔥 APPLY ATTRS
  btn.dataset.type = type;
  btn.dataset.variantId = variantId;
  btn.dataset.spId = sellingPlanId || '';

}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('#add-to-checkout');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const type = btn.dataset.type;      // oneTime | subscribe
  const vId  = btn.dataset.variantId;
  const spId = btn.dataset.spId;

  addToCartAndOpenDrawer(type, vId, spId);
});

function addToCartAndOpenDrawer(type, vId, spId) {
  const btn = document.getElementById('add-to-checkout');
  const ctaText = document.getElementById('product-final-price-cta-text');

  if (!btn || !ctaText) return;

  // Cache original CTA text
  if (!ctaText.dataset.originalText) {
    ctaText.dataset.originalText = ctaText.textContent.trim();
  }

  // UI feedback
  ctaText.textContent = 'Adding...';
  btn.classList.add('loading');
  btn.setAttribute('aria-busy', 'true');
  btn.disabled = true;

  const payload = {
    id: vId,
    quantity: 1
  };

  if (type !== 'oneTime' && spId) {
    payload.selling_plan = spId;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      refreshCartDrawer();
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
      alert('Unable to add item to cart. Please try again.');
    })
    .finally(() => {
      // Restore CTA text
      ctaText.textContent = ctaText.dataset.originalText;
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
}


function refreshCartDrawer() {
  const $cartDrawer = $('.drawer');

  if (!$cartDrawer.length) {
    console.error('Cart drawer element not found!');
    return;
  }

  $cartDrawer
    .removeClass('is-empty')
    .addClass('active')
    .load('/cart?view=drawer #CartDrawer', function () {
      document.body.classList.add('cart-open');
    });
}

document.addEventListener('click', function (e) {
  const thumb = e.target.closest('.gallery-thumb');
  if (!thumb) return;

  const gallery = thumb.closest('.product-gallery');
  if (!gallery) return;

  const index = thumb.dataset.index;

  const mainSlides = gallery.querySelectorAll('.gallery-image');
  const thumbs = gallery.querySelectorAll('.gallery-thumb');

  mainSlides.forEach(img => img.classList.remove('active'));
  thumbs.forEach(t => t.classList.remove('active'));

  gallery
    .querySelector(`.gallery-image[data-index="${index}"]`)
    ?.classList.add('active');

  thumb.classList.add('active');
});

$(document).on('click', '.thumb-arrow', function () {
  const $gallery = $(this).closest('.product-gallery');
  const $slider = $gallery.find('.custom-thumb-slider');
  const $item = $slider.find('.gallery-thumb').first(); // thumbnail class

  if (!$slider.length || !$item.length) return;

  const slideWidth = $item.outerWidth(true); // full width incl margin

  if ($(this).hasClass('left')) {
    $slider.animate(
      { scrollLeft: $slider.scrollLeft() - slideWidth },
      300
    );
  }

  if ($(this).hasClass('right')) {
    $slider.animate(
      { scrollLeft: $slider.scrollLeft() + slideWidth },
      300
    );
  }
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-variant-btn');
  if (!btn) return;

  const mediaId = btn.dataset.mediaId;
  if (!mediaId) return;

  //const gallery = btn.closest('.product-gallery');
  const gallery = $('.product-gallery')[0];

  if (!gallery) return;

  updateGalleryByMedia(mediaId, gallery);
});

function updateGalleryByMedia(mediaId, gallery) {
  const images = gallery.querySelectorAll('.gallery-image');
  const thumbs = gallery.querySelectorAll('.gallery-thumb');

  images.forEach(img => img.classList.remove('active'));
  thumbs.forEach(thumb => thumb.classList.remove('active'));

  const activeImage = gallery.querySelector(
    `.gallery-image[data-media-id="${mediaId}"]`
  );
  const activeThumb = gallery.querySelector(
    `.gallery-thumb[data-media-id="${mediaId}"]`
  );

  if (activeImage) activeImage.classList.add('active');
  if (activeThumb) {
    activeThumb.classList.add('active');
    activeThumb.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }
}

